import React, { useState } from 'react';
import { IoMdEyeOff } from "react-icons/io";
import { IoIosEye } from "react-icons/io";
import { GrShieldSecurity } from "react-icons/gr";
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { Button, Input } from '../../components';
import { COLORS } from '../../constants';
import './LoginPage.css';


const LoginPage = ({ onNavigate }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [users, setUsers] = useLocalStorage('prisma_users', []);

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
    setError('');
  };

  const handleLogin = () => {
    const user = users.find(u => u.email === formData.email && u.password === formData.password);
    if (user) {
      setError('');
      localStorage.setItem('usuarioLogado', JSON.stringify(user));
      onNavigate('dashboard');
    } else {
      setError('E-mail ou senha inválidos.');
    }
  };

  const handleRegister = () => {
    if (!formData.name || !formData.email || !formData.password || !formData.confirmPassword) {
      setError('Preencha todos os campos.');
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      setError('As senhas não coincidem.');
      return;
    }
    if (users.some(u => u.email === formData.email)) {
      setError('E-mail já cadastrado.');
      return;
    }
    const newUser = {
      name: formData.name,
      email: formData.email,
      password: formData.password,
    };
    setUsers([...users, newUser]);
    setError('');
    localStorage.setItem('usuarioLogado', JSON.stringify(newUser));
    onNavigate('dashboard');
  };

  return (
    <div className="login-page">
      <div className="login-hero">
        <img
          src="https://media.atomicatpages.net/u/KCCy0wC5yXhCHDajnGocwiv7uRr1/Pictures/cNgPgh8717261.png"
          alt="Prisma IA"
          className="login-logo"
        />
        <h1 className="login-title"></h1>
        <p className="login-subtitle">Plataforma Inteligente de Automação</p>
      </div>

      <div className="auth-tabs">
        <div
          className={`auth-tab ${isLogin ? 'active' : ''}`}
          onClick={() => setIsLogin(true)}
        >
          Fazer Login
        </div>
        <div
          className={`auth-tab ${!isLogin ? 'active' : ''}`}
          onClick={() => setIsLogin(false)}
        >
          Criar Conta
        </div>
      </div>

      {isLogin ? (
        <div className="auth-form">
          <Input
            type="email"
            placeholder="Seu e-mail"
            value={formData.email}
            onChange={handleChange('email')}
          />
          <div className="password-wrapper">
            <Input
              type={showPassword ? 'text' : 'password'}
              placeholder="Sua senha"
              value={formData.password}
              onChange={handleChange('password')}
              style={{ marginBottom: 0 }}
            />
            <div
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
              style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
            >
              {showPassword ? (
                <IoMdEyeOff size={22} color="#64748B" />
              ) : (
                <IoIosEye size={22} color="#64748B" />
              )}
            </div>
          </div>
          {error && <div style={{ color: '#EF4444', marginBottom: 8 }}>{error}</div>}
          <Button onClick={handleLogin}>Entrar</Button>
        </div>
      ) : (
        <div className="auth-form">
          <Input
            type="text"
            placeholder="Nome Completo"
            value={formData.name}
            onChange={handleChange('name')}
          />
          <Input
            type="email"
            placeholder="E-mail Corporativo"
            value={formData.email}
            onChange={handleChange('email')}
          />
          <Input
            type="password"
            placeholder="Senha Forte"
            value={formData.password}
            onChange={handleChange('password')}
          />
          <Input
            type="password"
            placeholder="Confirme a Senha"
            value={formData.confirmPassword}
            onChange={handleChange('confirmPassword')}
          />
          {error && <div style={{ color: '#EF4444', marginBottom: 8 }}>{error}</div>}
          <Button onClick={handleRegister}>Criar Minha Conta</Button>
        </div>
      )}

      <div className="login-footer">
        <div className="security-badge" style={{ display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'center', textAlign: 'center', width: '100%' }}>
          <GrShieldSecurity size={18} color="#00c689" />
          <span style={{ display: 'inline-block' }}>AMBIENTE SEGURO E CRIPTOGRAFADO</span>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;